import { render } from "./partsSelection.vue?vue&type=template&id=18d8cb78&scoped=true"
import script from "./partsSelection.vue?vue&type=script&lang=js"
export * from "./partsSelection.vue?vue&type=script&lang=js"

import "./partsSelection.vue?vue&type=style&index=0&id=18d8cb78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d8cb78"]])

export default __exports__